import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { playing: { type: Boolean, default: true } }

  connect() {
    this.carousel = bootstrap.Carousel.getOrCreateInstance(this.element)
  }

  toggle(event) {
    const btn = event.currentTarget
    if (this.playingValue) {
      this.carousel.pause()
      this.playingValue = false
      btn.setAttribute('aria-label', btn.dataset.labelPlay)
    } else {
      this.carousel.cycle()
      this.playingValue = true
      btn.setAttribute('aria-label', btn.dataset.labelPause)
    }
  }
}
